export default {
	default: [''],
	leftLabel: ['truncated-value--left-label']
};
